import { createFileRoute } from '@tanstack/react-router';
import { CloseFileRoute } from '@/components/finance/close';
import { parseSortRouteSearch } from '@/lib/finance/searchParamNamespace';

/**
 * CPH-014 Phase-3 sub-route. Mounts the review-and-file flow inside the
 * `CloseHubShell` so the "Back to report" affordance + masthead chip strip
 * persist (same pattern as Sort + Reconcile sub-routes). Search shape reuses
 * the Sort/Reconcile shape so `?returnTo=report&reportId=…` round-trips.
 */
export const Route = createFileRoute('/admin/finance/close/file')({
  component: CloseFileRoute,
  validateSearch: parseSortRouteSearch,
});
